// package imports
import React from 'react';
import { IconType } from 'react-icons';

// CSS imports
import './IconCard.css';

// Type imports
import { IconCardImgSize } from '../../types/iconCard/IconCardImgSize';
import { IconCardImageLocation } from '../../types/iconCard/IconCardImgLocation';

type Props = {
  ReactIcon?: IconType;
  img?: string;
  imgSize?: IconCardImgSize;
  imgLocation?: IconCardImageLocation;
  title: string;
  children?: React.ReactNode;
};

const IconCard: React.FC<Props> = ({
  ReactIcon,
  img,
  imgSize,
  imgLocation,
  title,
  children,
}: Props) => {
  return (
    <div className='IconCard'>
      <div
        className={`image-container ${
          imgSize === IconCardImgSize.SMALL
            ? 'small-image'
            : imgSize === IconCardImgSize.LARGE
            ? 'large-image'
            : imgSize === IconCardImgSize.FULL_WIDTH
            ? 'full-width-image'
            : ''
        } ${
          imgLocation === IconCardImageLocation.CENTER
            ? 'center-image'
            : imgLocation === IconCardImageLocation.RIGHT
            ? 'right-image'
            : ''
        }`}
      >
        {ReactIcon ? (
          <ReactIcon className='card-image' />
        ) : img ? (
          <img src={img} alt={title} className='card-image' />
        ) : null}
      </div>
      <span className='card-title'>{title}</span>
      <div className='card-content'>{children ? children : null}</div>
    </div>
  );
};

export default IconCard;
